/**
 * @generated SignedSource<<cacd8e5bf5d972c5198dd6e084c4ec82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticAdditionalInfo_subscription$data = {
  readonly additionalInfo: ReadonlyArray<{
    readonly key: string | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PaymentPixAutomaticAdditionalInfo_subscription";
};
export type PaymentPixAutomaticAdditionalInfo_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticAdditionalInfo_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticAdditionalInfo_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticAdditionalInfo_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Parameter",
      "kind": "LinkedField",
      "name": "additionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "97a3da69106d047c5087d072f2c0bd49";

export default node;
